import { Observable } from "rxjs";

export default function(wrapper, selector, eventName) {
  return Observable.fromEvent(
    document.querySelector(wrapper),
    eventName,
    e => ({ event: e, delegate: e.target.closest(selector) })
  ).filter(x => x.delegate !== null);
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/core/delegate.js